/**
 * 严重费规则定义管理类。
 */

class SeriousScrapped {
	constructor() {}

	/**
	 * 保存缺陷等级。
	 * @param {Array} enumerate
	 * @returns {String} 缺陷等级规则XML内容。
	 */
	saveDefectLevel(enumerate) {
		var xml_nodes = []
		xml_nodes.push(`<?xml version="1.0" encoding="UTF-8"?>`)
		xml_nodes.push(`<DefectLevel DefectLevelName="test">`)

		enumerate.forEach(element => {
			element.slightMax = element.normalMin
			element.normalMax = element.criticalMin

			xml_nodes.push(`<DefectType Name="${element.name}">`)
			xml_nodes.push(`<Unit>${element.unit}</Unit>`)
			xml_nodes.push(`<SlightMin>${element.slightMin}</SlightMin>`)
			xml_nodes.push(`<SlightMax>${element.slightMax}</SlightMax>`)
			xml_nodes.push(`<NormalMin>${element.normalMin}</NormalMin>`)
			xml_nodes.push(`<NormalMax>${element.normalMax}</NormalMax>`)
			xml_nodes.push(`<CriticalMin>${element.criticalMin}</CriticalMin>`)
			xml_nodes.push(`<CriticalMax>${element.criticalMax}</CriticalMax>`)
			xml_nodes.push(`</DefectType>`)
		})

		xml_nodes.push(`</DefectLevel>`)
		var xml = xml_nodes.join('\n')
		return xml
	}

	/**
	 * 保存连续废配置。
	 * @param {Array} enumerate
	 * @returns {String} 连续废规则XML内容。
	 */
	saveRuleInfo(jt_id, enumerate) {
		var xml_nodes = []
		xml_nodes.push(`<SDR JTID="${jt_id}">`)
		xml_nodes.push('<RulesUnit>sheet</RulesUnit>')

		enumerate.forEach(element => {
			xml_nodes.push(`<${element.type}>`)
			xml_nodes.push(`<Length>${element.length}</Length>`)
			xml_nodes.push(`<DefectNumber>${element.defectNumber}</DefectNumber>`)

			if (element.areaSegmentationSize) {
				xml_nodes.push(`<AreaSegmentationSize>${element.areaSegmentationSize}</AreaSegmentationSize>`)
			}

			xml_nodes.push(`</${element.type}>`)
		})

		xml_nodes.push(`</SDR>`)

		var xml = xml_nodes.join('\n')
		return xml
	}

	/**
	 * 获取缺陷等级。
	 * @param {String} xml
	 */
	getDefectLevelFromXml(xml) {
		var xmlDom = this._xmlToDom(xml)
		var root = xmlDom.documentElement
		var nodes = root.getElementsByTagName('DefectType')

		console.log('nodes', nodes)
		var result = []
		nodes.forEach(element => {
			var name = element.getAttribute('Name')
			var unitElement = element.getElementsByTagName('Unit')[0]
			var unit = 0
			if (unitElement.firstChild) {
				unit = parseInt(unitElement.firstChild.nodeValue)
			}

			var slightMin = element.getElementsByTagName('SlightMin')[0].firstChild.nodeValue
			var slightMax = element.getElementsByTagName('SlightMax')[0].firstChild.nodeValue
			var normalMin = element.getElementsByTagName('NormalMin')[0].firstChild.nodeValue
			var normalMax = element.getElementsByTagName('NormalMax')[0].firstChild.nodeValue
			var criticalMin = element.getElementsByTagName('CriticalMin')[0].firstChild.nodeValue
			var criticalMax = 10000

			// unit = parseInt(unit)
			slightMin = parseFloat(slightMin)
			slightMax = parseFloat(slightMax)
			normalMin = parseFloat(normalMin)
			normalMax = parseFloat(normalMax)
			criticalMin = parseFloat(criticalMin)
			criticalMax = parseFloat(criticalMax)

			// var Slight = [SlightMin, SlightMax]
			// var Normal = [NormalMin, NormalMax]
			// var Critical = [CriticalMin, CriticalMax]

			result.push({ name, unit, slightMin, slightMax, normalMin, normalMax, criticalMin, criticalMax })
		})

		console.log('result', result)

		return result
	}

	/**
	 * 获取连续费配置集合。
	 * @param {String} xml
	 */
	getRuleInfoFromXml(xml) {
		if (!xml) {
			return {}
		}

		var result = []
		var xmlDom = this._xmlToDom(xml)
		var root = xmlDom.documentElement

		var node_continueRules = root.getElementsByTagName('ContinueRules')
		node_continueRules.forEach(node => {
			var length = parseInt(node.getElementsByTagName('Length')[0].textContent)
			var defectNumber = parseInt(node.getElementsByTagName('DefectNumber')[0].textContent)
			result.push({
				length,
				defectNumber,
				type: 'ContinueRules',
				title: '连续废',
			})
		})

		var node_densityRules = root.getElementsByTagName('DensityRules')
		node_densityRules.forEach(node => {
			var length = parseInt(node.getElementsByTagName('Length')[0].textContent)
			var defectNumber = parseInt(node.getElementsByTagName('DefectNumber')[0].textContent)

			result.push({
				length,
				defectNumber,
				type: 'DensityRules',
				title: '密度废',
			})
		})

		var node_frequencyRules = root.getElementsByTagName('FrequencyRules')
		node_frequencyRules.forEach(node => {
			var length = parseInt(node.getElementsByTagName('Length')[0].textContent)
			var defectNumber = parseInt(node.getElementsByTagName('DefectNumber')[0].textContent)
			var areaSegmentationSize = parseInt(node.getElementsByTagName('AreaSegmentationSize')[0].textContent)
			result.push({
				length,
				defectNumber,
				areaSegmentationSize,
				type: 'FrequencyRules',
				title: '频次废',
			})
		})

		return result
	}

	/**
	 * DOMParser 对象解析 XML 文本并返回一个 XML Document 对象。
	 * @param {string} xmlStr
	 */
	_xmlToDom(xmlStr) {
		var xmlDoc = null

		/* DOMParser 对象解析 XML 文本并返回一个 XML Document 对象。
		 * 要使用 DOMParser，使用不带参数的构造函数来实例化它，然后调用其 parseFromString() 方法
		 * parseFromString(text, contentType) 参数text:要解析的 XML 标记 参数contentType文本的内容类型
		 * 可能是 "text/xml" 、"application/xml" 或 "application/xhtml+xml" 中的一个。注意，不支持 "text/html"。
		 */

		try {
			var domParser = new DOMParser()
			xmlDoc = domParser.parseFromString(xmlStr, 'text/xml')

			console.log('xmlDoc', xmlDoc)
		} catch (e) {
			console.error(e)
		}

		return xmlDoc
	}
}

export default new SeriousScrapped()
